import React from 'react';

interface Props {
	size: number;
}

export const InstitutionIcon: React.FC<Props> = props => (
	<svg
		aria-hidden='true'
		height={props.size}
		viewBox='0 0 24 24'
		width={props.size}
		xmlns='http://www.w3.org/2000/svg'
	>
		<title>institution</title>
		<path d='M20.9 9.46h-17a.41.41 0 01-.39-.27.42.42 0 01.12-.46l8.53-7.21a.41.41 0 01.53 0l8.53 7.21a.41.41 0 01-.27.73zM5 8.64h14.78l-7.41-6.27zM9.5 21.27H6.06V10H9.5zm-2.62-.82h1.8v-9.68h-1.8z' />
		<path d='M9.09 22.58H6.47a1.07 1.07 0 110-2.13h2.62a1.07 1.07 0 110 2.13zm-2.62-1.31a.25.25 0 100 .49h2.62a.25.25 0 100-.49zM17.62 22.58H15a1.07 1.07 0 110-2.13h2.62a1.07 1.07 0 110 2.13zM15 21.27a.25.25 0 100 .49h2.62a.25.25 0 100-.49zM9.09 10.77H6.47a1.07 1.07 0 110-2.13h2.62a1.07 1.07 0 110 2.13zM6.47 9.46a.25.25 0 100 .49h2.62a.25.25 0 100-.49zM17.62 10.77H15a1.07 1.07 0 110-2.13h2.62a1.07 1.07 0 110 2.13zM15 9.46a.25.25 0 100 .54h2.62a.25.25 0 100-.49z' />
		<path d='M18 21.27h-3.41V10H18zm-2.62-.82h1.8v-9.68h-1.8zM9.09 4.78H13a.33.33 0 01.33.33.33.33 0 01-.33.33H9.09a.32.32 0 01-.32-.33.32.32 0 01.32-.33zM7.13 6.75h3.93a.33.33 0 01.33.33.33.33 0 01-.33.33H7.13a.33.33 0 01-.33-.33.33.33 0 01.33-.33zM23.15 22.58H.85a.41.41 0 01-.41-.41.41.41 0 01.41-.41h22.3a.41.41 0 01.41.41.41.41 0 01-.41.41z' />
	</svg>
);
